import React, { useState, useContext } from "react";

import { Grid, Grow, Icon } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import TableDefault from "../../../../components/grid/TableDefault";
import Btn from "../../../../components/buttons/Btn";
import Chip from "../../../../components/basics/Chip";

import { Header, DivisorLabel, Divisor } from "../styles/Emissao";
import ModalEmissaoDI from "./ModalEmissaoDI";

import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoII = ({ ...props }) => {
  const {
    productDiTable,
    productIIFob,
    setProductIIFob,
    productIIFreightIm,
    setProductIIFreightIm,
    productIISafeIm,
    setProductIISafeIm,
    productIIThc,
    setProductIIThc,
    productIICustomsValue,
    setProductIICustomsValue,
    productIIOthers,
    setProductIIOthers,
    productIITaxCustoms,
    setProductIITaxCustoms,
    productIITaxIm,
    setProductIITaxIm,
    productIIAFRMM,
    setProductIIAFRMM,
    // productOthersSiscomex,
    // setProductOthersSiscomex,
    // productIIUnityValue,
    // setProductIIUnityValue,
    // productIIBcTax,
    // setProductIIBcTax,
    // productIIAliquot,
    // setProductIIAliquot,
    // productIIAliquotRed,
    // setProductIIAliquotRed,
    // productIIIof,
    // setProductIIIof,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly, saveBlocked } = useContext(EmissaoContext);

  const [modalDIOpen, setModalDIOpen] = useState(false);
  const columnsTableDi = [
    { label: "Número DI", id: "diNumeroRegistro" },
    {
      label: "Dt Registro",
      id: "diDataRegistro",
      format: (value) =>
        value?.diDataRegistro
          ? new Date(
              value.diDataRegistro.replaceAll("-", "/")
            ).toLocaleDateString("pt-Br")
          : "-",
    },
    {
      label: "UF",
      id: "diUfDes",
      format: (value) => value.diUfDes?.estado || "",
    },
    { label: "Local", id: "diLocalDes" },
    {
      label: "Dt Desembaraço",
      id: "diDataDes",
      format: (value) =>
        value?.diDataDes
          ? new Date(value.diDataDes.replaceAll("-", "/")).toLocaleDateString(
              "pt-Br"
            )
          : "-",
    },
    { label: "DrawBack", id: "diDrawback" },
    { label: "Sequência", id: "diSequencia" },
    { label: "Adição", id: "diAdd" },
  ];

  return (
    <>
      <ModalEmissaoDI
        modalDIOpen={modalDIOpen}
        setModalDIOpen={setModalDIOpen}
      />
      <Grid container spacing={2}>
        <Grow in={true}>
          <Grid item lg={12} sm={12}>
            <TableDefault
              columns={columnsTableDi}
              values={productDiTable}
              tableTitle={
                <Header>
                  <Grid container spacing={2}>
                    <Grid item lg={10} sm={8}>
                      <Chip label="DI" bgcolor="secondary" />
                    </Grid>
                    <Grid item lg={2} sm={4}>
                      <Btn
                        disabled={visualizationOnly || saveBlocked}
                        startIcon={
                          <Icon>{productDiTable.length ? "edit" : "add"}</Icon>
                        }
                        label={productDiTable.length ? "Editar" : "Adicionar"}
                        onClick={() => setModalDIOpen(true)}
                      />
                    </Grid>
                  </Grid>
                </Header>
              }
            />
          </Grid>
        </Grow>
        <Grow in={true} {...(true ? { timeout: 800 } : {})}>
          <Grid item lg={12}>
            <Card line="left">
              <Grid container spacing={2}>
                <DivisorLabel>Valores </DivisorLabel>
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIFob} // vl_frete + vl_seguro + vl_total
                    setValue={setProductIIFob}
                    size="small"
                    label="Valor FOB"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIFreightIm} // vl_frete
                    setValue={setProductIIFreightIm}
                    size="small"
                    label="Valor Frete de Importação"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIISafeIm} // vl_seguro
                    setValue={setProductIISafeIm}
                    size="small"
                    label="Valor Seguro de Importação"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>

                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIICustomsValue} // vl_total
                    setValue={setProductIICustomsValue}
                    size="small"
                    label="Valor Aduaneiro (CIF)"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Divisor />
                <DivisorLabel>Tributos (em reais) </DivisorLabel>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <TextField
                    value={productIITaxIm} // vl_ii
                    setValue={setProductIITaxIm}
                    size="small"
                    label="Valor imposto de importação (II)"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Divisor />
                <DivisorLabel>Outras taxas (em reais)</DivisorLabel>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <TextField
                    value={productIITaxCustoms} //vl_desp_adu_ii
                    setValue={setProductIITaxCustoms}
                    size="small"
                    label="Despesas Aduaneiras (SISCOMEX)"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIThc} // vl_capatazia
                    setValue={setProductIIThc}
                    size="small"
                    label="Taxa THC / Capatazia"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>

                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIAntidumping} // vl_antidumping
                    setValue={setProductIIAntidumping}
                    size="small"
                    label="Antidumping"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid> */}
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIAFRMM} // vl_taxa_afrmm
                    setValue={setProductIIAFRMM}
                    size="small"
                    label="Taxa AFRMM"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIOthers} // vl_outras_desp
                    setValue={setProductIIOthers}
                    size="small"
                    label="Outras Despesas"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>

                {/* Comentados para uso futuro */}
                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIAliquot}
                    setValue={setProductIIAliquot}
                    size="small"
                    label="Aliquota do II: (%)"
                    mask="decimal"
                  />
                </Grid> */}
                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIAliquotRed}
                    setValue={setProductIIAliquotRed}
                    size="small"
                    label="Aliquota da redução do II (%)"
                    mask="decimal"
                  />
                </Grid> */}
                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIIof}
                    setValue={setProductIIIof}
                    size="small"
                    label="Valor IOF"
                    mask="decimal"
                  />
                </Grid> */}
                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIUnityValue}
                    setValue={setProductIIUnityValue}
                    size="small"
                    label="Valor Unitário (II)"
                    mask="decimal"
                  />
                </Grid> */}
                {/* <Grid item lg={3} md={3} sm={6} xs={12}>
                  <TextField
                    value={productIIBcTax}
                    setValue={setProductIIBcTax}
                    size="small"
                    label="BC imposto de importação"
                    mask="decimal"
                  />
                </Grid> */}
              </Grid>
            </Card>
          </Grid>
        </Grow>
      </Grid>
    </>
  );
};

export default TabEmissaoII;
